var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rule-name-container"},[_c('h2',{staticClass:"rule-name h2"},[_vm._v("Task")])])}]

export { render, staticRenderFns }